import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SuiButtonComponent } from '@stride-ui/components';
import { SafeHtmlPipe } from '@move-frontend/portal-toolkit';
import { DialogComponent } from '../dialog/components/dialog/dialog.component';
import { DialogRef } from '../dialog/dialog-ref';
import { DIALOG_DATA } from '../dialog/dialog-tokens';

export interface InfoDialogData {
  title: string;
  message: string;
  closeLabel?: string;
}

@Component({
  selector: 'tnq-info-dialog',
  imports: [DialogComponent, SuiButtonComponent, TranslateModule, SafeHtmlPipe],
  templateUrl: './info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info-dialog.component.scss',
})
export class InfoDialogComponent {
  readonly dialogRef = inject<DialogRef<void>>(DialogRef);
  readonly data = inject<InfoDialogData>(DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
